"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  src/form/RadioGroup.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 11/12/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */

/* eslint-disable local-rules/unwrapped-i18n */
var propDoc = {
  checked: {
    description: "Indicates if the radio is selected (highlighted)",
    type: "boolean",
    required: true
  },
  size: {
    description: "Size of the radio element",
    type: "boolean",
    defaultValue: "16",
    required: true
  }
};
var demoProps = {
  checked: true
};

var Radio = function Radio(props) {
  var styles = useStylesheet(props);
  var checked = props.checked,
      className = props.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, "ripple")
  }, checked && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.dot)
  }));
};

Radio.demoProps = demoProps;
Radio.propDoc = propDoc;

var _default = (0, _mobxReact.observer)(Radio);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var _useTheme = (0, _providers.useTheme)(),
      primary = _useTheme.primary,
      surfaceLightest = _useTheme.surfaceLightest,
      borderPrimary = _useTheme.borderPrimary;

  var checked = props.checked,
      _props$size = props.size,
      size = _props$size === void 0 ? 16 : _props$size;
  var keyframes = {
    from: {
      transform: "scale(0, 0)",
      opacity: 0.5
    },
    to: {
      transform: "scale(1, 1)",
      opacity: 1
    }
  };
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        position: "relative",
        width: size,
        height: size,
        border: "solid 1px ".concat(checked ? primary : borderPrimary),
        borderRadius: "100%"
      },
      dot: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: "solid ".concat(Math.round(size / 2 * (1 - 0.6)), "px ").concat(surfaceLightest),
        borderRadius: "100%",
        backgroundColor: primary,
        animationName: [keyframes],
        animationDuration: "300ms"
      }
    });
  }, [checked, keyframes, size, primary, surfaceLightest, borderPrimary]);
};